import { HomeIcon, KebabHorizontalIcon } from '@primer/octicons-react';
import { Box, IconButton } from '@primer/react';
import Text from '../../components/ui/text';
import LiveStatus from './LiveStatus';
import { useLiveCheckinDataContext } from './useLiveCheckInDataContext';
import moment from 'moment';

const Toolbar = () => {
    const { ngayAn, caAnId, coSoId, tenCaAn, tenCoSo } = useLiveCheckinDataContext();
    return (
        <Box sx={{
            display: "flex",
            alignItems: "center",
            gap: 1
        }}>

            <Box sx={{ flex: 1, textAlign: "left" }}>
                <Text text={`${tenCoSo} - Điểm danh ăn ${tenCaAn} - ngày ${moment().format("DD/MM/YYYY")}`} sx={{
                    fontSize: 24,
                    fontWeight: 600
                }} />
            </Box>
            <Box>
                <LiveStatus />
            </Box>
            <Box>
                <a href='/'>
                    <IconButton icon={HomeIcon} aria-label='' />
                </a>
            </Box>
        </Box>
    );
};

export default Toolbar;